import React, { useState } from 'react';
import NavBar from '../../components/userHomeNavBar/navBar';
import SideBar from '../../components/userHomeSideBar/sideBar';
import InsertTextSection from '../../components/createBlog/InsertTextSection';
import InsertImageSection from '../../components/createBlog/InsertImageSection';
import { useAuth } from '../../context/DBContext';
import { useNavigate  } from 'react-router-dom';
import { Select, Input, Button, Space, Typography, message } from 'antd';

const { Title } = Typography;

const CreateBlogPage = () => {
    const [sections, setSections] = useState([]);
    const [title, setTitle] = useState('');
    const [category, setCategory] = useState('');  // Changed to string for single category
    const { createBlog, currentUser } = useAuth();
    const navigate = useNavigate();
    const [errorMessages, setErrorMessages] = useState({});

    // Initial categories (can be expanded)
    const defaultCategories = [
        '0-5 yrs',
        '6-13 yrs',
        '14 plus'
    ];

    const addTextSection = () => {
        setSections([...sections, { type: 'text', id: Date.now() }]);
    };

    const addImageSection = () => {
        setSections([...sections, { type: 'image', id: Date.now() }]);
    };

    const removeSection = (id) => {
        setSections(sections.filter(section => section.id !== id));
    };

    const handleSaveSection = (section) => {
        setSections(prevSections => prevSections.map(s => (s.id === section.id ? section : s)));
    };

    const handlePostBlog = async () => {
        const blogData = {
            title,
            author: currentUser.displayName,
            category,  // Now it's a single category string
            content: sections,
            comments: []
        };

        try {
            const blogId = await createBlog(blogData);
            // console.log('Blog posted with ID:', blogId);
            message.success('Blog post created successfully!');
            navigate('/blog/' + blogId);
        } catch (error) {
            // console.error('Failed to post blog:', error);
            message.error('Failed to create blog post');
        }
    };

    const validateForm = () => {
        const errors = {};
        if (!title) errors.title = 'Please provide a title';
        if (!category) errors.category = 'Please select a category';
        if (sections.length === 0) errors.sections = 'Please add at least one section';

        setErrorMessages(errors);
        return Object.keys(errors).length === 0;
    };

    const handleSubmit = () => {
        if (validateForm()) {
            handlePostBlog();
        }
    };

    return (
        <section>
            <div className="block-header">
                <div className="row">
                    <div className="col-lg-7 col-md-6 col-sm-12">
                        <Title level={2}>New Post</Title>
                    </div>
                </div>
            </div>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="body">
                                <Space direction="vertical" style={{ width: '100%' }} size="large">
                                    <div>
                                        <Input
                                            size="large"
                                            placeholder="Enter Blog title"
                                            value={title}
                                            onChange={e => setTitle(e.target.value)}
                                        />
                                        {errorMessages.title && 
                                            <div style={{ color: 'red', marginTop: '5px' }}>{errorMessages.title}</div>
                                        }
                                    </div>

                                    <div>
                                        <Select
                                            showSearch
                                            size="large"
                                            placeholder="Select or create a category"
                                            value={category}
                                            onChange={setCategory}
                                            style={{ width: '100%' }}
                                            options={defaultCategories.map(cat => ({ value: cat, label: cat }))}
                                            allowClear
                                            dropdownRender={(menu) => (
                                                <>
                                                    {menu}
                                                    <div style={{ padding: '8px', borderTop: '1px solid #e8e8e8' }}>
                                                        <Input.Search
                                                            placeholder="Type and press Enter to create your own category"
                                                            enterButton="Add"
                                                            onSearch={(value) => {
                                                                if (value) {
                                                                    setCategory(value);
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </>
                                            )}
                                        />
                                        {errorMessages.category && 
                                            <div style={{ color: 'red', marginTop: '5px' }}>{errorMessages.category}</div>
                                        }
                                        <div style={{ fontSize: '12px', color: 'gray', marginTop: '4px' }}>
                                            Select from list or create your own category
                                        </div>
                                    </div>
                                </Space>
                            </div>
                        </div>

                        {sections.map(section => (
                            section.type === 'text' ? (
                                <InsertTextSection
                                    key={section.id}
                                    id={section.id}
                                    removeSection={removeSection}
                                    onSave={handleSaveSection}
                                />
                            ) : (
                                <InsertImageSection
                                    key={section.id}
                                    id={section.id}
                                    removeSection={removeSection}
                                    onSave={handleSaveSection}
                                />
                            )
                        ))}
                        {errorMessages.sections && 
                            <div style={{ color: 'red', marginBottom: '16px' }}>{errorMessages.sections}</div>
                        }

                        <Space style={{ marginBottom: '20px' }}>
                            <Button
                                type="primary"
                                onClick={addTextSection}
                            >
                                Insert Text
                            </Button>
                            <Button
                                type="primary"
                                onClick={addImageSection}
                            >
                                Insert Image
                            </Button>
                        </Space>

                        <div style={{ textAlign: 'center', marginTop: '20px' }}>
                            <Button
                                type="primary"
                                size="large"
                                onClick={handleSubmit}
                            >
                                Post Blog
                            </Button>
                        </div>
                    </div>            
                </div>
            </div>
        </section>
    );
};

export default CreateBlogPage;
